export default "__VITE_ASSET__CY_D$wE6__"